function hasDeviceAlarm(location) {
  const eventId = Number(location?.lastLoc?.eventId)
  return (Number.isFinite(eventId) && eventId > 0 && eventId !== 35) || location?.lastAlarm != null
}

function calculateDeviceStatistics(locations = [], options = {}) {
  const uniqueLocations = new Map()
  for (const location of locations) {
    const sssid = location?.tracker?.sssid
    if (sssid != null) {
      uniqueLocations.set(String(sssid), location)
    }
  }

  const authorizedSssids = options.authorizedSssids
    ? new Set(Array.from(options.authorizedSssids).map((sssid) => String(sssid)))
    : null
  if (authorizedSssids) {
    for (const sssid of [...uniqueLocations.keys()]) {
      if (!authorizedSssids.has(sssid)) uniqueLocations.delete(sssid)
    }
    for (const sssid of authorizedSssids) {
      if (!uniqueLocations.has(sssid)) uniqueLocations.set(sssid, { tracker: { sssid } })
    }
  }

  const longOfflineTimeEnable = options.longOfflineTimeEnable === true
  const longOfflineTime = Number(options.longOfflineTime) || 1440
  const now = options.now instanceof Date ? options.now : new Date()

  let onlineDevices = 0
  let alarmDevices = 0
  const longOfflineSssids = getLongOfflineDeviceSssids([...uniqueLocations.values()], {
    longOfflineTimeEnable: longOfflineTimeEnable,
    longOfflineTime,
    now,
  })
  const longOfflineDevices = longOfflineSssids.size

  for (const location of uniqueLocations.values()) {
    const isOnline = location?.lastLoc?.online === true
    if (isOnline) {
      onlineDevices++
    }
    if (hasDeviceAlarm(location)) {
      alarmDevices++
    }

  }

  return {
    totalDevices: uniqueLocations.size,
    onlineDevices,
    alarmDevices,
    longOfflineDevices,
  }
}

function getDeviceStatusSssids(locations = [], filterType, options = {}) {
  const uniqueLocations = new Map()
  for (const location of locations) {
    const sssid = location?.tracker?.sssid
    if (sssid != null) {
      uniqueLocations.set(String(sssid), location)
    }
  }

  if (filterType === 'all') return new Set(uniqueLocations.keys())
  if (filterType === 'longOffline') {
    return getLongOfflineDeviceSssids([...uniqueLocations.values()], options)
  }

  const result = new Set()
  for (const [sssid, location] of uniqueLocations) {
    const isOnline = location?.lastLoc?.online === true
    const isAlarm = hasDeviceAlarm(location)
    if (
      (filterType === 'online' && isOnline) ||
      (filterType === 'offline' && !isOnline) ||
      (filterType === 'alarm' && isAlarm)
    ) {
      result.add(sssid)
    }
  }
  return result
}

function collectAuthorizedDeviceSssids(user, result = new Set()) {
  if (!user) return result
  for (const tracker of user.trackers || []) {
    if (tracker?.sssid != null) result.add(String(tracker.sssid))
  }
  for (const child of user.users || []) {
    if (child?.removed) continue
    collectAuthorizedDeviceSssids(child, result)
  }
  return result
}

function getLongOfflineDeviceSssids(locations = [], options = {}) {
  if (options.longOfflineTimeEnable === false) {
    return new Set()
  }

  const longOfflineTime = Number(options.longOfflineTime) || 1440
  const now = options.now instanceof Date ? options.now : new Date()
  const cutoffTime = new Date(now.getTime() - longOfflineTime * 60 * 1000)
  const result = new Set()

  for (const location of locations) {
    const sssid = location?.tracker?.sssid
    const receivedTime = location?.lastLoc?.receivedTime
    if (sssid == null || location?.lastLoc?.online === true || !receivedTime) {
      continue
    }

    const parsedTime = new Date(receivedTime)
    if (!Number.isNaN(parsedTime.getTime()) && parsedTime < cutoffTime) {
      result.add(String(sssid))
    }
  }

  return result
}

module.exports = {
  calculateDeviceStatistics,
  hasDeviceAlarm,
  getLongOfflineDeviceSssids,
  getDeviceStatusSssids,
  collectAuthorizedDeviceSssids,
}
